module.exports = __webpack_public_path__ + "71a0c229800d361d575c91936766d766.pdf";